import { render, staticRenderFns } from "./UserRoleManager.vue?vue&type=template&id=b42c15f8&scoped=true"
import script from "./UserRoleManager.vue?vue&type=script&lang=js"
export * from "./UserRoleManager.vue?vue&type=script&lang=js"
import style0 from "./UserRoleManager.vue?vue&type=style&index=0&id=b42c15f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42c15f8",
  null
  
)

export default component.exports